// noiseFilter.js - API service for noise filtering
import { fetchWithAuth } from "../apiutil";

export const noiseFilterAPI = {
  /**
   * Queue a noise filtering request
   * @param {string} accessToken - Current access token
   * @param {number} caseId - Source case ID
   * @param {number} clipId - Source clip ID
   * @param {Object} noiseFilterRequest - Complete noise filter request parameters
   * @returns {Promise<Object>} Response indicating success/failure
   */
  queueNoiseFilter: async (accessToken, caseId, clipId, noiseFilterRequest) => {
    console.log(
      `[noiseFilterAPI.queueNoiseFilter] Queueing noise filter request for clip ${clipId} in case ${caseId}`,
    );
    return fetchWithAuth(
      `/api/cases/${caseId}/clips/${clipId}/noiseFilter`,
      {
        method: "POST",
        body: JSON.stringify(noiseFilterRequest),
      },
      accessToken,
    );
  },
};
